"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonPane = void 0;
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const usePerformQuestionActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestionActions"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const InfoIcon_1 = __importDefault(require("@opsbase/web-icons/icons/InfoIcon"));
const IssueIcon_1 = __importDefault(require("@opsbase/web-icons/icons/IssueIcon"));
const MessageIcon_1 = __importDefault(require("@opsbase/web-icons/icons/MessageIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
require("react-quill/dist/quill.snow.css");
const makeMyClasses = () => ({
    bottomBar: {
        marginTop: 4,
        marginBottom: -16,
        width: '100%',
    },
    skipButton: {
        borderRadius: '0',
        marginLeft: -16,
    },
    button: {
        borderRadius: '0',
    },
});
function ButtonPane(props) {
    const { showingInfo, showingIssue, showingNotes, hasIssue, hasNotes, onClickInfo, onClickIssue, onClickNotes, } = props;
    const { allowIssuesAndNotes, mode } = (0, usePerform_1.default)();
    const { question, answer, rule } = (0, usePerformQuestion_1.default)();
    const { doSkip } = (0, usePerformQuestionActions_1.default)();
    const { html, files } = rule.richInfo;
    const hasInfo = !!(html === null || html === void 0 ? void 0 : html.length) || !!(files === null || files === void 0 ? void 0 : files.length);
    const enableNA = rule.enableNA;
    const skipped = answer === null || answer === void 0 ? void 0 : answer.notApplicable;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const viewMode = mode === 'view';
    const handleSkip = (0, react_1.useCallback)(() => {
        doSkip(!answer.notApplicable);
    }, [doSkip, answer]);
    return (0, react_1.useMemo)(() => {
        var _a;
        const allowOther = allowIssuesAndNotes && !skipped;
        const showSkip = !!enableNA && !viewMode;
        const showInfo = !viewMode && !!hasInfo;
        const showIssue = allowOther &&
            (!viewMode || hasIssue) &&
            question.type !== FormQuestionType_1.default.ISSUE &&
            !((_a = question.subQuestions) === null || _a === void 0 ? void 0 : _a.some(z => z.type === FormQuestionType_1.default.ISSUE));
        const showNotes = allowOther && (!viewMode || hasNotes);
        if (!showSkip && !showInfo && !showIssue && !showNotes)
            return null;
        return (react_1.default.createElement(Horizontal_1.default, { gutter: true, classes: { root: myCss.bottomBar } },
            !!showSkip && (react_1.default.createElement(Button_1.default, { label: skipped ? lib_i18n_1.default.t('unskip') : lib_i18n_1.default.t('skip'), onClick: handleSkip, classes: { root: myCss.skipButton }, small: true })),
            react_1.default.createElement(Pane_1.default, { grow: true }),
            !!showInfo && (react_1.default.createElement(Button_1.default, { small: true, background: showingInfo ? false : 'transparent', color: lib_palette_1.default.secondary, label: lib_i18n_1.default.t('info'), icon: react_1.default.createElement(InfoIcon_1.default, { size: 18 }), classes: { root: myCss.button }, onClick: onClickInfo })),
            !!showIssue && (react_1.default.createElement(Button_1.default, { small: true, background: showingIssue ? false : 'transparent', color: hasIssue ? lib_palette_1.default.primary : lib_palette_1.default.secondary, label: lib_i18n_1.default.t('issue'), icon: react_1.default.createElement(IssueIcon_1.default, { size: 18 }), classes: { root: myCss.button }, onClick: onClickIssue })),
            !!showNotes && (react_1.default.createElement(Button_1.default, { small: true, background: showingNotes ? false : 'transparent', color: hasNotes ? lib_palette_1.default.primary : lib_palette_1.default.secondary, label: lib_i18n_1.default.t('notes'), icon: react_1.default.createElement(MessageIcon_1.default, { size: 18 }), classes: { root: myCss.button }, onClick: onClickNotes }))));
    }, [
        allowIssuesAndNotes,
        enableNA,
        handleSkip,
        hasInfo,
        hasIssue,
        hasNotes,
        myCss,
        onClickInfo,
        onClickIssue,
        onClickNotes,
        question,
        showingInfo,
        showingIssue,
        showingNotes,
        skipped,
        viewMode,
    ]);
}
exports.ButtonPane = ButtonPane;
exports.default = ButtonPane;
